import React from 'react';
import { RefreshCw } from 'lucide-react';

export default function DefensibleMiniLoader({ label }: { label?: string }) {
  return (
    <div className="flex items-center gap-2 text-xs text-white/40">
      <RefreshCw className="h-3 w-3 animate-spin" />
      <span>{label ?? 'Loading…'}</span>
    </div>
  );
}
